/** @jsxImportSource theme-ui */
import { useUser } from "@auth0/nextjs-auth0";
import NavLink from "components/Header/NavLink";

interface NavProps {
  links: {
    href: string;
    text: string;
  }[];
}
const Nav = ({ links }: NavProps) => {
  const { user } = useUser();

  return (
    <nav
      sx={{
        display: ["none", null, "block"],
      }}
    >
      <ul
        sx={{
          p: "0px",
          display: "flex",
          justifyContent: "space-between",
          listStyleType: "none",
          li: {
            mx: 3,
          },
        }}
      >
        {links.map(({ href, text }) => (
          <li key={href}>
            <NavLink href={href} text={text} />
          </li>
        ))}

        {!user ? (
          <li>
            <NavLink
              href={"/api/auth/login?returnTo=/dashboard"}
              text={"Login"}
            />
          </li>
        ) : (
          <li>
            <NavLink href={"/dashboard"} text={"Dashboard"} />
          </li>
        )}
      </ul>
    </nav>
  );
};

export default Nav;
